/**
 * Asigna el PIN de supervisor de manifiestos. No muestra el PIN guardado.
 */
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { Button } from '../ui'
import { ManifiestoApiError, guardarPinSupervisor } from '../../services/manifiestos/manifiestosService'

const PIN_CODES: Record<string, string> = {
  PIN_INVALIDO: 'El PIN debe tener de 4 a 6 dígitos',
  USUARIO_NO_ENCONTRADO: 'No se encontró el usuario',
  USUARIO_SIN_PERMISO: 'El usuario no tiene permiso authorize_manifiesto',
}

const ManifiestoPinForm: React.FC = () => {
  const [userId, setUserId] = useState('')
  const [pin, setPin] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    const id = Number(userId)
    if (!Number.isInteger(id) || id <= 0) {
      toast.error('Indica el id del usuario', { position: 'top-center' })
      return
    }
    if (!/^\d{4,6}$/.test(pin)) {
      toast.error(PIN_CODES.PIN_INVALIDO, { position: 'top-center' })
      return
    }
    setSaving(true)
    try {
      await guardarPinSupervisor(id, pin)
      setPin('')
      toast.success('PIN guardado', { position: 'top-center' })
    } catch (error) {
      const code = error instanceof ManifiestoApiError ? error.code : ''
      toast.error(PIN_CODES[code] || (error instanceof Error ? error.message : 'No se pudo guardar el PIN'), {
        position: 'top-center',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="p-4 md:p-6 max-w-lg mx-auto">
      <h2 className="text-xl font-semibold mb-2">PIN de supervisor</h2>
      <p className="text-sm text-gray-500 mb-6">
        El usuario ya debe tener el permiso authorize_manifiesto. El PIN no es la contraseña de ingreso y no se vuelve a mostrar.
      </p>
      <form className="flex flex-col gap-4" onSubmit={(event) => void handleSubmit(event)}>
        <label className="flex flex-col gap-1 text-sm text-gray-600">
          Id de usuario
          <input
            className="border border-gray-300 rounded-md px-3 py-2"
            inputMode="numeric"
            value={userId}
            onChange={(event) => setUserId(event.target.value)}
            aria-label="Id de usuario"
          />
        </label>
        <label className="flex flex-col gap-1 text-sm text-gray-600">
          PIN
          <input
            className="border border-gray-300 rounded-md px-3 py-2"
            type="password"
            inputMode="numeric"
            autoComplete="new-password"
            value={pin}
            onChange={(event) => setPin(event.target.value)}
            aria-label="PIN del supervisor"
          />
        </label>
        <Button type="submit" variant="primary" isLoading={saving}>
          Guardar PIN
        </Button>
      </form>
    </div>
  )
}

export default ManifiestoPinForm
